
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "nuxt": {
    "buildId": "803b8e89-9752-4654-8ff4-d21cb8afa81f"
  },
  "firebaseConfig": {
    "apiKey": "AIzaSyDkNDECBfWNPgGMsL9EIjCfzq_-w92XzHc",
    "authDomain": "jammy-trip.firebaseapp.com",
    "projectId": "jammy-trip",
    "storageBucket": "jammy-trip.firebasestorage.app",
    "messagingSenderId": "335274698051",
    "appId": "1:335274698051:web:9143eb3f91addbdbdd3bf6",
    "measurementId": "G-G9X0LWHQDX"
  },
  "vuefireOptions": {
    "optionsApiPlugin": false,
    "auth": true,
    "config": {
      "apiKey": "AIzaSyDkNDECBfWNPgGMsL9EIjCfzq_-w92XzHc",
      "authDomain": "jammy-trip.firebaseapp.com",
      "projectId": "jammy-trip",
      "storageBucket": "jammy-trip.firebasestorage.app",
      "messagingSenderId": "335274698051",
      "appId": "1:335274698051:web:9143eb3f91addbdbdd3bf6",
      "measurementId": "G-G9X0LWHQDX"
    }
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}



export default /*@__PURE__*/ defuFn(inlineConfig)
